import React from 'react';
import PropTypes from 'prop-types';

import pages from './pages/pages';

import StoryBoard from './components/StoryBoard';

import './assets/styles/main.scss';

const DecisionTrees = ({ startAt }) => {
  return (
    <div className='decision-trees container-lg'>
      <StoryBoard pages={pages} startAt={startAt} />
    </div>
  );
};

DecisionTrees.propTypes = {
  startAt: PropTypes.string
};

export default DecisionTrees;
